/* eslint import/no-extraneous-dependencies: 0 */
/* eslint object-shorthand: 0 */
/* eslint func-names: 0 */
/* eslint max-len: 0 */
import * as Blockly from 'blockly';
import colors from '../utils/colors';
import options from '../utils/blocksOptions';

// Reinicia el contador static tiempoIniciofuncion de las funcion_ciudad_luces*. No confundir con
// base_delay (delay(ms)): es otro bloque pese al nombre.
Blockly.Blocks.base_delay_tren = {
  init: function () {
    this.setColour(colors.COLOUR_CONTROL);
    this.appendDummyInput('').appendField('Reiniciar el tiempo');
    this.setInputsInline(false);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_CONTROLS_BASE_DELAY_TOOLTIP);
  },
};

// Solo tiene sentido dentro de una funcion_ciudad_luces*, que declara la static tiempoIniciofuncion.
Blockly.Blocks.ciudad_tiempo = {
  init: function () {
    this.setOutputShape(options.SHAPES.ROUND);
    this.setColour(colors.COLOUR_CONTROL);
    this.appendDummyInput('').appendField('tiempo');
    this.setInputsInline(false);
    this.setOutput(true);
    this.setTooltip(Blockly.Msg.LANG_ENTRADAS_CIUDAD_LDR_TOOLTIP);
  },
};

// Fotorresistor de la maqueta (pin fijo A0).
Blockly.Blocks.ciudad_ldr = {
  init: function () {
    this.setOutputShape(options.SHAPES.ROUND);
    this.setColour(colors.COLOUR_ENTRADAS);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/Nivel_de_luz.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA)
      .appendField(Blockly.Msg.LANG_ENTRADAS_CIUDAD_LDR);
    this.setInputsInline(false);
    this.setOutput(true);
    this.setTooltip(Blockly.Msg.LANG_ENTRADAS_CIUDAD_LDR_TOOLTIP);
  },
};

// El nombre de la función C que generan va por tabla: no se deriva del label. Se asignan con
// `Blockly.Blocks.<tipo> =` literal porque scripts/blockly-parity.js detecta bloques con una regex
// estática y una clave armada en runtime le queda invisible.

const funcionCiudadLuces = (label) => ({
  init: function () {
    this.setColour(colors.COLOUR_PROCEDURES);
    this.appendDummyInput().appendField(label);
    this.appendStatementInput('DO');
    this.setPreviousStatement(false);
    this.setNextStatement(false);
    this.setInputsInline(true);
    this.setTooltip(Blockly.Msg.LANG_CONTROLS_REPEAT_TOOLTIP);
  },
});

Blockly.Blocks.funcion_ciudad_luces = funcionCiudadLuces('Secuencias de luces interior');
Blockly.Blocks.funcion_ciudad_luces2 = funcionCiudadLuces('Secuencias de luces exterior');
Blockly.Blocks.funcion_ciudad_luces3 = funcionCiudadLuces('Apertura y cierre de flor');
Blockly.Blocks.funcion_ciudad_luces4 = funcionCiudadLuces('Luminaria calle');
Blockly.Blocks.funcion_ciudad_luces5 = funcionCiudadLuces('Pantalla de mensajes');
Blockly.Blocks.funcion_ciudad_luces6 = funcionCiudadLuces('Luminaria Teatro Colón');
Blockly.Blocks.funcion_ciudad_luces7 = funcionCiudadLuces('Luminaria obelisco');
Blockly.Blocks.funcion_ciudad_luces8 = funcionCiudadLuces('Pantalla de mensajes');
Blockly.Blocks.funcion_ciudad_luces9 = funcionCiudadLuces('Barrera de paso');
Blockly.Blocks.funcion_ciudad_luces10 = funcionCiudadLuces('Estación Retiro');
Blockly.Blocks.funcion_ciudad_luces11 = funcionCiudadLuces('Cúpula del planetario');
Blockly.Blocks.funcion_ciudad_luces12 = funcionCiudadLuces('Secuencia cascada');
Blockly.Blocks.funcion_ciudad_luces13 = funcionCiudadLuces('Secuencia lineal');
Blockly.Blocks.funcion_ciudad_luces14 = funcionCiudadLuces('Pantalla de mensajes');
Blockly.Blocks.funcion_ciudad_luces15 = funcionCiudadLuces('Luminaria exterior');

const otraFuncion = (label) => ({
  init: function () {
    this.setColour(colors.COLOUR_PROCEDURES);
    this.appendDummyInput('').appendField(label);
    this.setInputsInline(false);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
  },
});

Blockly.Blocks.otra_funcion = otraFuncion('Apertura y cierre flor');
Blockly.Blocks.otra_funcion2 = otraFuncion('Secuencia de luces exterior');
Blockly.Blocks.otra_funcion3 = otraFuncion('Secuencia de luces interior');
Blockly.Blocks.otra_funcion4 = otraFuncion('Pantalla de mensajes');
Blockly.Blocks.otra_funcion5 = otraFuncion('Luminaria Teatro Colón');
Blockly.Blocks.otra_funcion6 = otraFuncion('Luminaria obelisco');
Blockly.Blocks.otra_funcion7 = otraFuncion('Luminaria calle');
Blockly.Blocks.otra_funcion8 = otraFuncion('Estación Retiro');
Blockly.Blocks.otra_funcion9 = otraFuncion('Barrera de paso');
Blockly.Blocks.otra_funcion10 = otraFuncion('Pantalla de mensajes');
Blockly.Blocks.otra_funcion11 = otraFuncion('Cúpula del planetario');
Blockly.Blocks.otra_funcion12 = otraFuncion('Secuencia cascada');
Blockly.Blocks.otra_funcion13 = otraFuncion('Secuencia lineal');
Blockly.Blocks.otra_funcion14 = otraFuncion('Pantalla de mensajes');
Blockly.Blocks.otra_funcion15 = otraFuncion('Luminaria exterior');
